"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConnectInit = exports.transformToSocketURL = void 0;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _react = require("react");
var _useWebSocket = require("./useWebSocket");
var _socketConfig = require("./socket-config");
var _sockets = require("../../../../entities/sockets");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const defaultLogPrefix = '';
const defaultHideLogs = true;
const transformToSocketURL = url => {
  if (!url) return null;
  if (url.includes(_socketConfig.PROTOCOLS.HTTPS)) {
    return url.replace(_socketConfig.PROTOCOLS.HTTPS, _socketConfig.PROTOCOLS_WS.WSS);
  }
  return url.replace(_socketConfig.PROTOCOLS.HTTP, _socketConfig.PROTOCOLS_WS.WS);
};
exports.transformToSocketURL = transformToSocketURL;
const useConnectInit = _ref => {
  let {
    mustBeOpen,
    baseUrl,
    socketId,
    logPrefix = defaultLogPrefix,
    hideLogs = defaultHideLogs
  } = _ref;
  const dispatch = (0, _reactRedux.useDispatch)();
  const socket = (0, _reactRedux.useSelector)((0, _sockets.selectSocketById)({
    socketId
  }));
  const readyState = (0, _reactRedux.useSelector)((0, _sockets.selectSocketStatusById)({
    socketId
  }));
  const socketUrl = transformToSocketURL(baseUrl);
  (0, _useWebSocket.useConnectSocket)({
    mustBeOpen,
    socketId,
    socketUrl,
    logPrefix,
    hideLogs
  });
  (0, _react.useEffect)(() => {
    if (socket && !mustBeOpen) {
      dispatch((0, _sockets.disconnectSocketAction)({
        socketId,
        logPrefix,
        hideLogs
      }));
    }
  }, [dispatch, socketId, logPrefix, hideLogs, socket, mustBeOpen]);
  return {
    socket,
    readyState
  };
};
exports.useConnectInit = useConnectInit;
useConnectInit.propTypes = {
  mustBeOpen: _propTypes.default.bool.isRequired,
  baseUrl: _propTypes.default.string.isRequired,
  socketId: _propTypes.default.string.isRequired,
  logPrefix: _propTypes.default.string,
  hideLogs: _propTypes.default.bool
};
useConnectInit.defaultProps = {
  logPrefix: defaultLogPrefix,
  hideLogs: defaultHideLogs
};